// extracted by mini-css-extract-plugin
module.exports = {"linkTextContent":"Footer_linkTextContent__1yD5a","linkText":"Footer_linkText__1Y6_N","copyright":"Footer_copyright__1SBdq","fblineIcons":"Footer_fblineIcons__2coWe"};